module.exports = __webpack_public_path__ + "media/lymphangioma.effbfeb4.wav";